import { render, staticRenderFns } from "./newaccount.vue?vue&type=template&id=6f2dac0a&scoped=true&"
import script from "./newaccount.vue?vue&type=script&lang=js&"
export * from "./newaccount.vue?vue&type=script&lang=js&"
import style0 from "./newaccount.vue?vue&type=style&index=0&id=6f2dac0a&scoped=true&lang=scss&"
import style1 from "./newaccount.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2dac0a",
  null
  
)

export default component.exports